import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShareContentModal, { useGetSharingPermissions } from 'screens/ShareModal';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
function Share(_ref) {
  var Component = _ref.as;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset,
    playlistId = _useAssetViewerContex.params.playlistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShareModalOpen = _useState2[0],
    setShareModal = _useState2[1];
  var _useGetSharingPermiss = useGetSharingPermissions({
      name: asset === null || asset === void 0 ? void 0 : asset.name,
      contentIds: asset !== null && asset !== void 0 && asset.id ? [asset.id] : [],
      contentParentPlaylistId: playlistId || undefined
    }),
    shareData = _useGetSharingPermiss.shareData,
    isLoading = _useGetSharingPermiss.isLoading;
  if (!asset || isLoading) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, {
    icon: "external",
    onClick: function onClick() {
      return setShareModal(true);
    },
    disabled: isShareModalOpen,
    id: "actionpanel_share_button_".concat(asset.id)
  }, t('actions_share')), isShareModalOpen && /*#__PURE__*/React.createElement(ShareContentModal, {
    data: shareData,
    onClose: function onClose() {
      return setShareModal(false);
    }
  }));
}
export default Share;